import posthog from "posthog-js";

/**
 * Typed PostHog event tracking.
 *
 * Route every important click through `trackEvent` so event names and their
 * properties stay consistent. PostHog is initialised in
 * `src/components/PostHogAnalytics.tsx`; if the token is absent the singleton
 * is never loaded and these calls are safe no-ops.
 *
 * To add a new event: add a key + property shape to `AnalyticsEventMap`.
 */
export type AnalyticsEventMap = {
	agent_submitted: {
		source: "agent" | "user" | (string & {});
		has_api_key: boolean;
	};
	agent_claim_clicked: {
		agent_slug: string;
		verification_status: string;
	};
	agent_shared: {
		agent_slug: string;
	};
	profit_margin_unlock_clicked: {
		agent_slug: string;
	};
	agent_badge_copied: {
		agent_slug?: string;
		format: "html" | "md" | "embed";
		surface: "dashboard" | "claim-dialog";
	};
	agent_visited: {
		agent_slug: string;
	};
	advertise_clicked: {
		surface: string;
	};
	ad_checkout_started: {
		spot_id?: string;
		tier?: string;
	};
	startup_listing_checkout_started: {
		plan: string;
	};
	growth_checkout_started: {
		plan: string;
	};
	founder_shared: {
		founder_slug: string;
	};
	founder_x_profile_visited: {
		founder_slug: string;
		x_handle: string;
	};
};

export type AnalyticsEventName = keyof AnalyticsEventMap;

export function trackEvent<Name extends AnalyticsEventName>(
	name: Name,
	properties: AnalyticsEventMap[Name],
): void {
	posthog?.capture(name, properties);
}
